import { BluTextField } from "@bludata/components";
import { Typography } from "@mui/material";
import React from "react";
import { memo } from "react";
import { useWatch, useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../store";

export const Name = memo(() => {
  const watch = useWatch({ name: "name" });
  const { setValue, trigger } = useFormContext();
  const { openForm } = useSelector((state: RootState) => state.studiRoot);

  return (
    <>
      <div style={{ width: "60%" }}>
        <Typography variant="subtitle2" sx={{ p: "3px 0px 0 0" }}>
          Nome
        </Typography>
        <BluTextField
          disabled={openForm === "info"}
          value={watch}
          name="Nome"
          onChange={(event: any) => {
            setValue("name", event.target.value);
            trigger();
          }}
        />
      </div>
    </>
  );
});
